exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".column-date-range{white-space:normal;width:270px}.column-date-range .vdp-datepicker__calendar{position:fixed;margin-left:-120px}.vdp-datepicker__clear-button>i{margin-left:-26px;position:absolute;top:10px;right:9px}.vdp-datepicker__clear-button>i>span{display:none}.vdp-datepicker{display:inline-block;width:130px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75a12843","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/metronic/table/header/DateRange.vue
// module id = h6E7
// module chunks = 0 1 2